/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Passed props"
    }), "\n", _jsxs(_components.p, {
      children: ["If the styled target is a simple element (e.g. ", _jsx(_components.code, {
        children: "styled.div"
      }), "), styled-components passes through any known HTML attribute to the DOM. If it is a custom React component (e.g. ", _jsx(_components.code, {
        children: "styled(MyComponent)"
      }), "), styled-components passes through all props."]
    }), "\n", _jsx(_components.p, {
      children: "This example shows how all props of the Input component are passed on to the\nDOM node that is mounted, as with React elements."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// Create an Input component that'll render an <input> tag with some styles\nconst Input = styled.input<{ $inputColor?: string; }>`\n  padding: 0.5em;\n  margin: 0.5em;\n  color: ${props => props.$inputColor || \"#BF4F74\"};\n  background: papayawhip;\n  border: none;\n  border-radius: 3px;\n`;\n\n// Render a styled text input with the standard input color, and one with a custom input color\nrender(\n  <div>\n    <Input defaultValue=\"@probablyup\" type=\"text\" />\n    <Input defaultValue=\"@geelen\" type=\"text\" $inputColor=\"rebeccapurple\" />\n  </div>\n);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Note how the ", _jsx(_components.code, {
        children: "$inputColor"
      }), " prop is not passed to the DOM, but ", _jsx(_components.code, {
        children: "type"
      }), " and ", _jsx(_components.code, {
        children: "defaultValue"
      }), " are? The ", _jsx(_components.code, {
        children: "styled"
      }), " function is smart enough to filter non-standard attributes automatically for you."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
